import version from './version';

export const GaasLibraryInfo = {
    version: version
};